import React from 'react';
import PropTypes from 'prop-types';

function getInitials(name) {
	return name.split(" ").map((part)=>part.slice(0,1).toUpperCase()).slice(0,2).join("");
}

const Avatar = ({ user:{name,avatar} }) => {
	if (avatar && avatar.length) {
		return <img alt={getInitials(name)} className="flex-shrink-0 mr-3 unsw-avatar" src={avatar} width="36" height="36" />
	} else if (name && name.length) {
		return <div className="bg-dark-4 flex-shrink-0 mr-3 text-white-primary unsw-avatar">{getInitials(name)}</div>
	} else {
		return <div className="bg-dark-4 flex-shrink-0 mr-3 text-white-primary unsw-avatar">&nbsp;</div>
	}
}

Avatar.propTypes = {
	user: PropTypes.object.isRequired
}

export default Avatar;